import "./style.less";
export default function authTestController(
    userId, // resolved
    $scope,
    API_SERVER,
    $http
) {
    $scope.testApi = function () {
        const url = API_SERVER + "/users";

        $http.get(url).then(function (res) {
            return res;
        });
    };
}
